<section>
    <article class="card container-fluid">
        <h2 class="card-header text-center font-weight-bold text-uppercase py-4">Properties You Rent</h2>
        <article class="table-header">

          <!-- Toolbar -->
          <div class="toolbar">
              <!-- Add Property -->
              <button type="button" class="dt-button" (click)="addPropertyDialog()">
                <span>Add Property</span>
                <mdb-icon class="text-success ml-1" fas icon="plus" size="md"></mdb-icon>
              </button>
            </div>
        </article>
        <div class="card-body" style="overflow-x:auto;">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
                <thead>
                    <tr>
                        <th>Entry Date</th>
                        <th>Am I Renting?</th>
                        <th>Rent Amount</th>
                        <th>Owner Name</th>
                        <th>Manager Name</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>Zip Code</th>
                        <th>Unit #</th>
                        <th>Bedrooms</th>
                        <th>Bathrooms</th>
                        <th>Last Modified</th>
                        <th>Move In Checklist Completed</th>
                        <th>Attachments</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let property of properties">
                        <td class="text-nowrap" [attr.data-sort]="sortDate(property.entryDate)">{{ property.entryDate | date }}</td>
                        <td>
                          <mat-slide-toggle aria-label="toggle property for rent" color="primary" [disabled]="property.saving"
                              [(ngModel)]="property.isRented" [ngModelOptions]="{ standalone: true }" (change)="saveRentedFlag(property)">
                            {{ property.isRented | boolean:'Yes':'No' }}
                          </mat-slide-toggle>
                        </td>
                        <td>{{ property.rentAmount | currency: property.rentCurrency:'symbol':'1.0-2' }}</td>
                        <td>{{ property.ownerName }}</td>
                        <td>{{ property.managerName }}</td>
                        <td>{{ property.contactPhone }}</td>
                        <td>{{ property.email }}</td>
                        <td>{{ property.address }}</td>
                        <td>{{ property.city }}</td>
                        <td>{{ property.zipCode }}</td>
                        <td>{{ property.unitNumber }}</td>
                        <td>{{ property.bedrooms }}</td>
                        <td>{{ property.bathrooms }}</td>
                        <td class="td-lastmodified">{{ property.lastUpdated | date:'medium' }}</td>
                        <td>{{ property.isMoveInInspectionChecklistCompleted ? 'Yes' : 'No' }}</td>
                        <td>{{ property.files?.length || 0 }}</td>
                        <td class="td-actions">
                            <!-- Edit -->
                            <button type="button" class="mr-2" (click)="editProperty(property)"><mdb-icon fas icon="pen"></mdb-icon></button>

                            <!-- Checklist -->
                            <a class="mr-2" *ngIf="property.isRented || property.moveInInspectionChecklistCompletedID"
                                [routerLink]="['./condition-checklist']" [queryParams]="{ propertyid: property._id }">
                              <button type="button"><mdb-icon fas icon="clipboard-list"></mdb-icon></button>
                            </a>

                            <!-- Files -->
                            <a class="mr-2" [routerLink]="['./files']" [queryParams]="{ propertyid: property._id }">
                              <button type="button"><mdb-icon fas icon="paperclip"></mdb-icon></button>
                            </a>

                            <!-- Delete -->
                            <button type="button" class="mr-2 btn-danger" (click)="deleteProperty(property)"><mdb-icon fas icon="trash"></mdb-icon></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </article>
</section>
